var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1818 3.20801H1.81818C1.56714 3.20801 1.36364 3.41321 1.36364 3.66634V20.1663C1.36364 20.4195 1.56714 20.6247 1.81818 20.6247H18.1818C18.4329 20.6247 18.6364 20.4195 18.6364 20.1663V3.66634C18.6364 3.41321 18.4329 3.20801 18.1818 3.20801ZM1.81818 1.83301C0.814028 1.83301 0 2.65382 0 3.66634V20.1663C0 21.1789 0.814027 21.9997 1.81818 21.9997H18.1818C19.186 21.9997 20 21.1789 20 20.1663V3.66634C20 2.65382 19.186 1.83301 18.1818 1.83301H1.81818Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1363 -2.4836e-08C6.51285 -1.11195e-08 6.81812 0.307804 6.81812 0.6875L6.81812 3.89583C6.81812 4.27553 6.51285 4.58333 6.1363 4.58333C5.75974 4.58333 5.45448 4.27553 5.45448 3.89583L5.45448 0.6875C5.45448 0.307804 5.75974 -3.85526e-08 6.1363 -2.4836e-08Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3182 -2.4836e-08C14.6947 -1.11195e-08 15 0.307804 15 0.6875L15 3.89583C15 4.27553 14.6947 4.58333 14.3182 4.58333C13.9416 4.58333 13.6364 4.27553 13.6364 3.89583L13.6364 0.6875C13.6364 0.307804 13.9416 -3.85526e-08 14.3182 -2.4836e-08Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.54532,
    cy: 8.91667,
    rx: 0.909091,
    ry: 0.916666,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99991,
    cy: 8.91667,
    rx: 0.909091,
    ry: 0.916666,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.4545,
    cy: 8.91667,
    rx: 0.909091,
    ry: 0.916666,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.54532,
    cy: 12.5837,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99991,
    cy: 12.5837,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.4545,
    cy: 12.5837,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.54532,
    cy: 16.2497,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99991,
    cy: 16.2497,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.4545,
    cy: 16.2497,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.b6cfd7afc19acd0530a74c81704cab90.svg";
export { ForwardRef as ReactComponent };